module.exports = __webpack_public_path__ + "static/media/14UNEP1.66ee4342.jpg";